import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  Sort,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { GetAllStores, GetPartById, GetPartHistoryById } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";

const PartHistory = () => {
  const navigate = useNavigate();
  let param = useParams();
  const part_id = param.p_id;
  const [Part, setPart] = useState("");
  const [Stores, setStores] = useState([]);
  const [Store, setStore] = useState(null);
  const [Parts, setParts] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);

  const colsGrid = [
    {
      field: "datetime",
      headerText: "Transaction Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "165",
      width: "195",
      maxWidth: "200",
      textAlign: "Center",
    },
    {
      field: `start_quantity`,
      headerText: "Start Qty",
      minWidth: "115",
      width: "135",
      maxWidth: "140",
      textAlign: "right",
    },
    {
      field: `adjustment`,
      headerText: "Adjustment",
      minWidth: "125",
      width: "155",
      maxWidth: "160",
      textAlign: "right",
    },
    {
      field: `end_quantity`,
      headerText: "End Qty",
      minWidth: "115",
      width: "135",
      maxWidth: "140",
      textAlign: "right",
    },
    {
      field: "t_type",
      headerText: "Transaction Type",
      minWidth: "160",
      width: "320",
      maxWidth: "420",
      textAlign: "left",
    },
    {
      field: "user",
      headerText: "User",
      minWidth: "80",
      width: "140",
      maxWidth: "220",
      textAlign: "left",
    },
    {
      field: "note",
      headerText: "Transaction Note",
      minWidth: "180",
      width: "280",
      maxWidth: "880",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      setStore(option);
    } else setStore(null);
  };

  useEffect(() => {
    async function fetchData() {
      if (part_id) {
        TimeoutUtility.resetTimeout();
        setloading(true);
        trackPromise(
          GetPartHistoryById(part_id, Store?.value || null)
            .then((result) => setParts(result.data))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [part_id, Store]);

  useEffect(() => {
    async function fetchData() {
      if (part_id) {
        TimeoutUtility.resetTimeout();
        await GetPartById(part_id)
          .then((resp) => {
            setPart(`${resp.data.part_number} - ${resp.data.description}`);
          })
          .catch((err) => console.log(err.message));
        await GetAllStores()
          .then((resp) => {
            const storeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.store_id,
            }));
            setStores(storeOptions || []);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="PART HISTORY" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={8} className="container-col">
              <TextInputField
                label="Part Number & Description:"
                name="location"
                value={Part}
                placeholder="Part Number & Description:"
                disabled
              />
            </Col>
            <Col md={3} className="container-col">
              <SelectField
                label="Store:"
                name="store"
                value={Store}
                options={Stores}
                onChange={handleSelectChange}
                placeholder="Store"
                isClearable
              />
            </Col>
            <Col md={12} className="container-col">
              {loading && promiseInProgress ? (
                <LoadingIndicator />
              ) : (
                <GridComponent
                  dataSource={Parts}
                  height="calc(60vh - 116px)"
                  allowSorting
                  allowResizing
                  className="custom-grid1 mt-4"
                  rowHeight={30}
                  toolbar={["Search"]}
                >
                  <ColumnsDirective>
                    {colsGrid.map((item, index) => (
                      <ColumnDirective key={index} {...item} />
                    ))}
                  </ColumnsDirective>
                  <Inject services={[Resize, Toolbar, Sort]} />
                </GridComponent>
              )}
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default PartHistory;
